import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    // cmr
    cmrEmit: {
      tableData: [],
      totalCmrsEmit: 0
    },
    queryCmrEmit: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo(),
      shipFrom: '',
      shipTo: '',
      emailTransportist: ''
    },
    listSelectedFiltersCmrEmit: [],

    // Combo estados cmr
    optionsFilterStatusCmr: [],
    optionsFilterReceiverCmrEmit: [],
    optionsFilterSenderCmrEmit: [],

    // Datos Select Filtros cmr
    optionsFilterDateCreationCmrEmit: [],
    optionsFilterDateIssueCmrEmit: [],
    optionsFilterDeliveryNumberCmrEmit: [],
    optionsFilterDeliveryDateCmrEmit: [],

    // cmr borradores
    cmrDraft: {
      tableData: [],
      totalCmrsDraft: 0
    },
    queryCmrDraft: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      searchType: 'EMITTED',
      status: 'DRAFT',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo(),
      shipFrom: '',
      shipTo: '',
      emailTransportist: ''
    },
    listSelectedFiltersCmrDraft: [],

  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla cmr
    isShowNumberCmrEmit: true,
    isShowOrderCmrEmit: false,
    isShowGroupCmrEmit: false,
    isShowVehiclePlateCmrEmit: true,
    isShowTrailerPlateCmrEmit: true,
    isShowSecondTrailerPlateCmrEmit: true,
    isShowSenderPartyCmrEmit: true,
    isShowSenderCentreCmrEmit: true,
    isShowReceiverPartyCmrEmit: true,
    isShowReceiverCentreCmrEmit: true,
    isShowCreationDateTimeCmrEmit: true,
    isShowStatusCmrEmit: true,
    isShowServiceCmrEmit: true,
    isShowSendDateCmrEmit: true,
    isShowTransportistCmrEmit: true,
    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesCmrEmit: true,
    
  
  }
  return local
}
function setByUserLocalCMR () {
  if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr) {
    const cmrLocal = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).cmr
    const local = {
      // Columnas Tabla cmr
      isShowNumberCmrEmit: cmrLocal.isShowNumberCmrEmit,
      isShowOrderCmrEmit: cmrLocal.isShowOrderCmrEmit,
      isShowGroupCmrEmit: cmrLocal.isShowGroupCmrEmit,
      isShowVehiclePlateCmrEmit: cmrLocal.isShowVehiclePlateCmrEmit,
      isShowTrailerPlateCmrEmit: cmrLocal.isShowTrailerPlateCmrEmit,
      isShowSecondTrailerPlateCmrEmit: cmrLocal.isShowSecondTrailerPlateCmrEmit,
      isShowSenderPartyCmrEmit: cmrLocal.isShowSenderPartyCmrEmit,
      isShowSenderCentreCmrEmit: cmrLocal.isShowSenderCentreCmrEmit,
      isShowReceiverPartyCmrEmit: cmrLocal.isShowReceiverPartyCmrEmit,
      isShowReceiverCentreCmrEmit: cmrLocal.isShowReceiverCentreCmrEmit,
      isShowCreationDateTimeCmrEmit: cmrLocal.isShowCreationDateTimeCmrEmit,
      isShowStatusCmrEmit: cmrLocal.isShowStatusCmrEmit,
      isShowServiceCmrEmit: cmrLocal.isShowServiceCmrEmit,
      isShowSendDateCmrEmit: cmrLocal.isShowSendDateCmrEmit,
      isShowTransportistCmrEmit: cmrLocal.isShowTransportistCmrEmit,
      isShowEmailTransportistCmrEmit: typeof cmrLocal.isShowEmailTransportistCmrEmit === 'boolean' ? cmrLocal.isShowEmailTransportistCmrEmit : true,
      // Columnas tabla lineas emitidas
      isShowItemCodeLinesCmrEmit: cmrLocal.isShowItemCodeLinesCmrEmit,
     
      }
    return local
  } else {
    return initLocal()
  }
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {

    // Columnas Tabla cmr
    isShowNumberCmrEmit: true,
    isShowOrderCmrEmit: false,
    isShowGroupCmrEmit: false,
    isShowVehiclePlateCmrEmit: true,
    isShowTrailerPlateCmrEmit: true,
    isShowSecondTrailerPlateCmrEmit: true,
    isShowSenderPartyCmrEmit: true,
    isShowSenderCentreCmrEmit: true,
    isShowReceiverPartyCmrEmit: true,
    isShowReceiverCentreCmrEmit: true,
    isShowCreationDateTimeCmrEmit: true,
    isShowStatusCmrEmit: true,
    isShowServiceCmrEmit: true,
    isShowSendDateCmrEmit: true,
    isShowTransportistCmrEmit: true,
    isShowEmailTransportistCmrEmit: true,
    // Columnas Tabla lineas emitidas
    isShowItemCodeLinesCmrEmit: true,
    
  },

  session: initSession()
}

// getters
const getters = {
  // Datos Tabla cmr
  cmrEmit: state => {
    return state.session.cmrEmit
  },
  queryCmrEmit: state => {
    return state.session.queryCmrEmit
  },
  listSelectedFiltersCmrEmit: state => {
    return state.session.listSelectedFiltersCmrEmit
  },


  // Datos Select Filtros cmr
  optionsFilterDateCreationCmrEmit: state => {
    return state.session.optionsFilterDateCreationCmrEmit
  },
  optionsFilterDateIssueCmrEmit: state => {
    return state.session.optionsFilterDateIssueCmrEmit
  },
  optionsFilterDeliveryDateCmrEmit: state => {
    return state.session.optionsFilterDeliveryDateCmrEmit
  },  
  optionsFilterDeliveryNumberCmrEmit: state => {
    return state.session.optionsFilterDeliveryNumberCmrEmit
  },

  // Combo estados
  optionsFilterStatusCmr: state => {
    return state.session.optionsFilterStatusCmr
  },
  optionsFilterReceiverCmrEmit: state => {
    return state.session.optionsFilterReceiverCmrEmit
  },
  optionsFilterSenderCmrEmit: state => {
    return state.session.optionsFilterSenderCmrEmit
  },

  // Columnas Tabla cmr
  isShowNumberCmrEmit: state => {
    return state.local.isShowNumberCmrEmit
  },
  isShowOrderCmrEmit: state => {
    return state.local.isShowOrderCmrEmit
  },
  isShowGroupCmrEmit: state => {
    return state.local.isShowGroupCmrEmit
  },
  isShowVehiclePlateCmrEmit: state => {
    return state.local.isShowVehiclePlateCmrEmit
  },
  isShowTrailerPlateCmrEmit: state => {
    return state.local.isShowTrailerPlateCmrEmit
  },
  isShowSecondTrailerPlateCmrEmit: state => {
    return state.local.isShowSecondTrailerPlateCmrEmit
  },
  isShowSenderPartyCmrEmit: state => {
    return state.local.isShowSenderPartyCmrEmit
  },
  isShowSenderCentreCmrEmit: state => {
    return state.local.isShowSenderCentreCmrEmit
  },
  isShowReceiverPartyCmrEmit: state => {
    return state.local.isShowReceiverPartyCmrEmit
  },
  isShowReceiverCentreCmrEmit: state => {
    return state.local.isShowReceiverCentreCmrEmit
  },
  isShowCreationDateTimeCmrEmit: state => {
    return state.local.isShowCreationDateTimeCmrEmit
  },
  isShowStatusCmrEmit: state => {
    return state.local.isShowStatusCmrEmit
  },
  isShowServiceCmrEmit: state => {
    return state.local.isShowServiceCmrEmit
  },
  isShowSendDateCmrEmit: state => {
    return state.local.isShowSendDateCmrEmit
  },
  isShowTransportistCmrEmit: state => {
    return state.local.isShowTransportistCmrEmit
  },
  isShowEmailTransportistCmrEmit: state => {
    return state.local.isShowEmailTransportistCmrEmit
  },


  // Columnas lineas pedido emitidas
  isShowItemCodeLinesCmrEmit: state => {
    return state.local.isShowItemCodeLinesCmrEmit
  },

  // Datos Tabla cmr borradores
  cmrDraft: state => {
    return state.session.cmrDraft
  },
  queryCmrDraft: state => {
    return state.session.queryCmrDraft
  },
  listSelectedFiltersCmrDraft: state => {
    return state.session.listSelectedFiltersCmrDraft
  }

}

// actions
const actions = {
  // Crear key Usuario
  // Crear key Usuario
  setUserNameCMR ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalCMR()
    }
  },
  async isNewVersionCmrLocalState ({ state }, localStorage) {
    const isnew =  fn.isNewVersion(state, localStorage.cmr)
    return isnew
  },

  /* CMR */
  /**
  * Servicio para traer los cmr  .
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getCmrNotes ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/searchCMRweb',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false})
        }
      })

      commit('CMR_EMIT_STATE', {
        tableData: response.data.content,
        totalCmrsEmit: response.data.totalElements
      })


      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener eventos de un cmr
   */
   async getCmrEvents ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/getevent?id=' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    /**
   * Servicio para obtener adjuntos de un cmr
   */
   async getCmrAttachs ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/getattachs?id=' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
      }
    },

  /**
   * Servicio para crear evento de CMR con adjunto
   */
  async setCmrEventAttach ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/seteventattach',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId,
          type: params.type,
          subType: params.subType,
          description: params.description,
          location: params.location || null,
          attachFile1: params.attachFile1,
          attachFile2: params.attachFile2 || null,
          attachFile3: params.attachFile3 || null
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   /**
   * Servicio para obtener eventos de un cmr
   */
   async getCmrHistory ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/gethistory?id=' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Servicio para traer detalle de un CMR
  async getCmrDetail ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/cmrdetail?id=' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getCmrStops ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/getstops',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- getCmrStops', error.response)
      throw error.response
    }
  },

  async createCmrStop ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/createstop',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId,
          shipFrom: params.shipFrom,
          stopPlace: params.stopPlace
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- createCmrStop', error.response)
      throw error.response
    }
  },

  async deleteCmrStop ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/deletestop',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.stopId
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- deleteCmrStop', error.response)
      throw error.response
    }
  },

  async validateFinalStops ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/transportdocument/' + params.cmrId + '/validatefinalstops',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {}
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- validateFinalStops', error.response)
      throw error.response
    }
  },

  async validateStops ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/transportdocument/' + params.cmrId + '/validatestops',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {}
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- validateStops', error.response)
      throw error.response
    }
  },

  async getTransportists ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/gettransportist',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          idProject: params.idProject || undefined,
          nameTransportist: params.nameTransportist || undefined,
          nifTransportist: params.nifTransportist || undefined,
          emailTransportist: params.emailTransportist || undefined
        },
        paramsSerializer: rawParams => {
          return qs.stringify(convertDates(rawParams), { skipNulls: true })
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      const content = Array.isArray(response.data) ? response.data : []
      return { content, totalElements: content.length }
    } catch (error) {
      console.log('ERROR --- getTransportists', error.response)
      throw error.response
    }
  },

/**
 * Servicio para descargar zip con los PDF de los cmr indicados
 * @param {*} cmrIds
 */
    async downloadCmrPdfMultiple ({ commit, state }, params) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/transportdocument/pdf',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            cmrIds: params.cmrIds,
            searchType: params.searchType
          },
          responseType: 'blob',
          paramsSerializer: params => {
            return qs.stringify(convertDates(params), { indices: false})
          }
        })
  
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        })
        let filename = 'pdfs-cmr.zip'
        const fileGroup = /([^;]+;\s+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
        if (fileGroup?.[2]) {
          filename = fileGroup[2]
        }
        FileSaver.saveAs(blob, filename)
  
        fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
        return filename
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },
   /**
 * Servicio para descargar pdf de un cmr
 * @param {*} cmrId
 */
   async downloadCmrHistoryPdf ({ commit, state }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/' + params.cmrHistoryId + '/pdfhistory',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'cmr.pdf')
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
   /**
 * Servicio para descargar attach de un cmr
 * @param {*} attachId
 */
    async downloadCmrAttach ({ commit, state }, params) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/transportdocument/' + params.attachId + '/attach',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            fileName: params.fileName
          },
          responseType: 'blob'
        })
  
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        })
        let filename = 'cmr.pdf'
        const fileGroup = /([^;]+;\s+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
        if (fileGroup?.[2]) {
          filename = fileGroup[2]
        }
        FileSaver.saveAs(blob, filename)
  
        fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
        return filename
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

 // Servicio para traer detalle de un CMR
  async signPdf ({ commit, rootState }, cmrId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/signPdf/' + cmrId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
    /**
     * Servicio para modificar los datos de un documento de transporte/cmr
     * @param {*} params
     */
  async modifyCmr ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/transportdocument/' + params.cmrId,
         baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          cmrNumber: params.cmrNumber,
          chargerObservations: params.chargerObservations,
          nameTransportist: params.nameTransportist,
          emailTransportist: params.emailTransportist,
          nifTransportist: params.nifTransportist,
          transportistObservations: params.transportistObservations,
          vehiclePlate: params.vehiclePlate,
          trailerPlate: params.trailerPlate,
          statusCode: params.statusCode,
          observations: params.observations
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async changeSendDate ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/transportdocument/changesenddate',
         baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId,
          documentDate: params.sendDate ? dayjs(params.sendDate).format('DD-MM-YYYY') : null,
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para guardar firma biométrica de un CMR
   */
  async saveBiometricSignature ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/' + params.cmrId + '/biometric-signature',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          signedPdfBase64: params.signedPdfBase64,
          signatureMetadata: params.signatureMetadata,
          signatureType: params.signatureType,
          signerName: params.signerName,
          signerEmail: params.signerEmail,
          observations: params.observations
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR saveBiometricSignature --- ', error.response)
      throw error.response
    }
  },
 /**
 * Servicio para descargar pdf de un cmr por link generado desde el qr del pdf
 * @param {*} cmrId
 */
   async downloadPdfByLink ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/downloadcmrbylink',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          link: params.link
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'cmr.pdf')
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState?.session?.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Acceso al detalle de un CMR a través de un link, sin necesidad de autenticación previa.
   * @param {*} param0 
   * @param {*} params 
   * @returns 
   */
  async getCmrByLink ({
    commit,
    rootState
  }, params) {
    try {
      // Primera llamada para obtener el token
      const firstResponse = await axios({
        method: 'GET',
        url: '/transportdocument/getcmrbylink',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          link: params.link
        }
      })
      
      // Extraer el token de la respuesta
      const token = firstResponse.data.linkAccessToken ? `Bearer ${firstResponse.data.linkAccessToken}` : null
      
      if (!token) {
        throw new Error('No se pudo obtener el token del link')
      }
      
      // Segunda llamada CON el token en el header para obtener los permisos del usuario
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/getcmrbylink',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: {
          Authorization: token
        },
        params: {
          link: params.link
        }
      })
      
      // Extraer los datos del CMR y la información del usuario
      const cmrData = response.data
      const myUserInfoTO = response.data.myUserInfoTO
      
      const user = {
        data: myUserInfoTO,
        authToken: token,
        isActive: true
      }

      // Establecer el token para las siguientes peticiones
      axios.defaults.headers.common.Authorization = token
      commit('JWT_STATE', token, { root: true })
      commit('ACTIVE_USER_STATE', user, { root: true })
      commit('URL_IN_STATE', cmrData.projectName, { root: true })

      return cmrData
    } catch (error) {
      console.log('ERROR --- getCmrByLink', error.response)
      throw error.response
    }
  },

  async downloadCmrMetadata ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/' + params.cmrId + '/metadata',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          searchType: params.searchType
        },
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'cmr-metadata')
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para crear una observación en un CMR
   * @param {*} params { cmrId, observation }
   */
  async createCmrObservation ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/createobservation',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          cmrId: params.cmrId,
          observation: params.observation,
          observationType: params.observationTypeId
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para enviar el link de un CMR
   * @param {*} params { cmrId }
   */
  async sendCmrLink ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/sendlink',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener el link QR de un CMR
   * @param {*} params { cmrId }
   */
  async getCmrQrLink ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/linkqr',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.id
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async changeCmrPlates ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/changeplates',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId,
          vehiclePlate: params.vehiclePlate,
          trailerPlate: params.trailerPlate,
          secondTrailerPlate: params.secondTrailerPlate,
          nameTransportist: params.nameTransportist,
          nifTransportist: params.nifTransportist,
          emailTransportist: params.emailTransportist,
          transportistObservations: params.transportistObservations,
          idTransportist: params.idTransportist
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar una observación de un CMR
   * @param {*} observationId
   */
  async updateCmrStatus ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'put',
        url: '/transportdocument/updatestatusweb',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId,
          status: params.statusCode,
          motive: params.motive
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getOptionsCmrObservationType ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/observation-types',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async changeCmrObservations ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/changetransportistobservation',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId,
          chargerObservation: params.chargerObservation,
          transportistObservation: params.transportistObservation,
          observationTypeId: params.observationTypeId
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async updateGeneralCargo ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: `/transportdocument/${params.cmrId}/updategeneralcargo`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          nature: params.nature,
          weight: params.weight,
          idUnitOfMeasure: params.idUnitOfMeasure
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async updateCmrAuthorization ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'PUT',
        url: `/transportdocument/${params.cmrId}/authorization`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          authorizationNumber: params.authorizationNumber,
          senderAgency: params.senderAgency,
          validityDateFrom: params.validityDateFrom,
          validityDateTo: params.validityDateTo
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar una observación de un CMR
   * @param {*} observationId
   */
  async deleteCmrObservation ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/deleteobservation',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.observationId,
          cmrId: params.cmrId
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar una línea de un CMR
   * @param {*} lineId
   */
  async deleteCmrLine ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/deleteline',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.lineId,
          cmrId: params.cmrId,
          lineNumber: params.lineNumber
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para eliminar un CMR borrador
   * @param {*} cmrId
   */
  async deleteCmr ({ commit, rootState }, params) {
    try {
      const cmrId = typeof params === 'object' && params !== null
        ? (params.cmrId || params.id)
        : params

      const response = await axios({
        method: 'POST',
        url: '/transportdocument/deletecmr',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          id: cmrId,
          cmrId
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- deleteCmr', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para duplicar un CMR borrador
   * @param {*} cmrId
   */
  async duplicateCmr ({ commit, rootState }, params) {
    try {
      const cmrId = typeof params === 'object' && params !== null
        ? (params.cmrId || params.id)
        : params
      const cmrNumber = typeof params === 'object' && params !== null
        ? params.cmrNumber
        : null
      const sendDate = typeof params === 'object' && params !== null
        ? params.sendDate
        : null

      const response = await axios({
        method: 'POST',
        url: '/transportdocument/cmrduplicate',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: cmrId,
          cmrId,
          cmrNumber,
          sendDate: sendDate ? dayjs(sendDate).format('DD-MM-YYYY') : null
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- duplicateCmr', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los tipos de estados de cmrs
   */
  async getOptionsFilterStatusCmr ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/cmrstatus',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterStatusCmr = response.data
      commit('OPTIONS_FILTER_STATUS_CMR', optionsFilterStatusCmr)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterStatusCmr
    } catch (error) {
      console.log('status cmr : ', error)
      throw error.response
    }
  },
  
  /**
     * Servicio para Exportar Todas las cmr  a CSV
     */
  async downloadCmrCsv ({ commit, rootState }, params) {
    try {
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,        
        url: '/transportdocument/csv',
        params: params,
        responseType: 'blob',
        headers: { 'Accept-Language': params.activeLang },
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'cmr.csv')
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos Tabla cmr Emitidas
  cmrsEmitState: ({ commit }, payload) => {
    commit('CMR_EMIT_STATE', payload)
  },
  queryCmrEmitState: ({ commit }, payload) => {
    commit('QUERY_CMR_EMIT_STATE', payload)
  },
  listSelectedFiltersCmrEmitState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_CMR_EMIT_STATE', payload)
  },

 
  // Datos Select Filtros cmr Emitidas
  optionsFilterDateCreationCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_CREATION_CMR_EMIT', payload)
  },
  optionsFilterDateIssueCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DATE_ISSUE_CMR_EMIT', payload)
  },
  optionsFilterDeliveryDateCmrEmitState : ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_DATE_CMR_EMIT', payload)
  },  
  optionsFilterDeliveryNumberCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_DELIVERY_NUMBER_CMR_EMIT', payload)
  },


  // Combo estados
  optionsFilterStatusCmrState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_STATUS_CMR', payload)
  },
  optionsFilterReceiverCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_RECEIVER_CMR_EMIT', payload)
  },
  optionsFilterSenderCmrEmitState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SENDER_CMR_EMIT', payload)
  },

  // Columnas Tabla cmr
  isShowNumberCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_NUMBER_CMR_EMIT', payload)
  },
  isShowOrderCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_ORDER_CMR_EMIT', payload)
  },
  isShowGroupCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_GROUP_CMR_EMIT', payload)
  },
  isShowVehiclePlateCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_VEHICLE_PLATE_CMR_EMIT', payload)
  },
  isShowTrailerPlateCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_TRAILER_PLATE_CMR_EMIT', payload)
  },
  isShowSecondTrailerPlateCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SECOND_TRAILER_PLATE_CMR_EMIT', payload)
  },
  isShowSenderPartyCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SENDER_PARTY_CMR_EMIT', payload)
  },
  isShowSenderCentreCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SENDER_CENTRE_CMR_EMIT', payload)
  },
  isShowReceiverPartyCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEIVER_PARTY_CMR_EMIT', payload)
  },
  isShowReceiverCentreCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_RECEIVER_CENTRE_CMR_EMIT', payload)
  },
  isShowCreationDateTimeCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_CREATION_DATE_CMR_EMIT', payload)
  },
  isShowStatusCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_CMR_EMIT', payload)
  },
  isShowServiceCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SERVICE_CMR_EMIT', payload)
  },
  isShowSendDateCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_SEND_DATE_CMR_EMIT', payload)
  },
  isShowTransportistCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_TRANSPORTIST_CMR_EMIT', payload)
  },
  isShowEmailTransportistCmrEmitAction: ({ commit }, payload) => {
    commit('IS_SHOW_EMAIL_TRANSPORTIST_CMR_EMIT', payload)
  },
    
  // Columnas lineas emitidas
  isShowItemCodeLinesCmrEmittAction: ({ commit }, payload) => {
    commit('IS_SHOW_ITEMCODE_CMR_EMIT', payload)
  },

  // Datos Tabla cmr borradores
  cmrsDraftState: ({ commit }, payload) => {
    commit('CMR_DRAFT_STATE', payload)
  },
  queryCmrDraftState: ({ commit }, payload) => {
    commit('QUERY_CMR_DRAFT_STATE', payload)
  },
  listSelectedFiltersCmrDraftState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_CMR_DRAFT_STATE', payload)
  },

  /**
   * Servicio para crear un CMR en estado borrador (DRAFT)
   */
  async createCmrDraft ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/createdraft',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.cmrId || null,
          projectId: params.idProject || null,
          sellerId: params.idSeller || null,
          buyerId: params.idBuyer || null,
          cmrNumber: params.cmrNumber,
          sendDate: params.sendDate ? dayjs(params.sendDate).format('DD-MM-YYYY') : null,
          vehiclePlate: params.vehiclePlate,
          trailerPlate: params.trailerPlate,
          secondTrailerPlate: params.secondTrailerPlate,
          carrierName: params.nameTransportist,
          carrierTaxIdentificationNumber: params.nifTransportist,
          carrierDriverEmail: params.emailTransportist,
          observation: params.transportistObservations,
          chargerObservation: params.chargerObservations,
          authorizationNumber: params.authorizationNumber || null,
          senderAgency:   params.senderAgency || null,
          validityDateFrom: params.validityDateFrom ? dayjs(params.validityDateFrom).format('DD-MM-YYYY') : null,
          validityDateTo: params.validityDateTo ? dayjs(params.validityDateTo).format('DD-MM-YYYY') : null,
          nature: params.nature || null,
          weight: params.weight ?? null,
          idUnitOfMeasure: params.idUnitOfMeasure ?? 0,
          sellerCentres: (params.sellerCentres || []).map(c => ({
            centre: c.centre ? { id: c.centre.id, centreCode: c.centre.centreCode, description: c.centre.description } : null
          })),
          buyerCentres: (params.buyerCentres || []).map(c => ({
            centre: c.centre ? { id: c.centre.id, centreCode: c.centre.centreCode, description: c.centre.description } : null
          })),
          originPlace: params.originPlace || null,
          destinationPlace: params.destinationPlace || null 
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- createCmrDraft', error.response)
      throw error.response
    }
  },

  async getCmrDraftNotes ({ commit, rootState }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      // Forzar siempre el filtro de estado DRAFT
      data.query.status = 'DRAFT'
      const response = await axios({
        method: 'GET',
        url: '/transportdocument/searchCMRweb',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      commit('CMR_DRAFT_STATE', {
        tableData: response.data.content,
        totalCmrsDraft: response.data.totalElements
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- getCmrDraftNotes', error.response)
      throw error.response
    }
  },

  async saveCmrLine ({ commit, rootState }, params) {
    try {
      // Si params es un array, usarlo directamente; si no, crear array de un elemento
      const lines = Array.isArray(params) ? params : [params]
      
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/createline',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: lines.map(line => ({
          id: line.id || null,
          cmrId: line.cmrId,
          lineNumber: String(line.lineNumber),
          description: line.description,
          weight: line.weight || 0,
          idUnitOfMeasure: line.unitOfMeasureId || null,
          lineCode: line.articleCode || null,
          lineCodeSeller: line.articleCodeSeller || null,
          idCmrStop: line.stopId || null
        }))
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- saveCmrLine', error.response)
      throw error.response
    }
  },

  async deleteCmrLines ({ commit, rootState }, { cmrId, lines }) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/deletelines',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: lines.map(line => ({
          cmrId,
          id: line.id,
          lineNumber: String(line.lineNumber)
        }))
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- deleteCmrLines', error.response)
      throw error.response
    }
  },

    async deleteCmrAttach ({ commit, rootState }, { cmrId, id }) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/transportdocument/deleteattach',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data:{
          cmrId,
          id: id
         }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- deleteCmrAttach', error.response)
      throw error.response
    }
  },

  async changeCmrStatusToPending ({ commit, rootState }, { cmrId }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: `/transportdocument/${cmrId}/status/pending`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- changeCmrStatusToPending', error.response)
      throw error.response
    }
  },
   async changeCmrStatusToDraft ({ commit, rootState }, { cmrId }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: `/transportdocument/${cmrId}/status/draft`,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- changeCmrStatusToDraft', error.response)
      throw error.response
    }
  },
}

// mutations
const mutations = {
  resetSessionCmr (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  cmrDatesSuperAdmin (state) {
    state.session.queryCmrEmit.creationDateTimeFrom = fn.initDateFrom(1)
    state.session.queryCmrsReceived.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // cmr
  'CMR_EMIT_STATE' (state, payload) {
    state.session.cmrEmit = payload
  },
  'QUERY_CMR_EMIT_STATE' (state, payload) {
    state.session.queryCmrEmit = payload
  },
  'LIST_SELECTED_FILTERS_CMR_EMIT_STATE' (state, payload) {
    state.session.listSelectedFiltersCmrEmit = payload
  },


  // Datos Select Filtros cmr
  'OPTIONS_FILTER_DATE_CREATION_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDateCreationCmrEmit = payload
  },
  'OPTIONS_FILTER_DATE_ISSUE_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDateIssueCmrEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_DATE_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryDateCmrEmit = payload
  },
  'OPTIONS_FILTER_DELIVERY_NUMBER_CMR_EMIT' (state, payload) {
    state.session.optionsFilterDeliveryNumberCmrEmit = payload
  },

  // Combo estados cmr
  'OPTIONS_FILTER_STATUS_CMR' (state, payload) {
    state.session.optionsFilterStatusCmr = payload
  },
  'OPTIONS_FILTER_RECEIVER_CMR_EMIT' (state, payload) {
    state.session.optionsFilterReceiverCmrEmit = payload
  },
  'OPTIONS_FILTER_SENDER_CMR_EMIT' (state, payload) {
    state.session.optionsFilterSenderCmrEmit = payload
  },

  // Columnas Tabla cmr
  'IS_SHOW_NUMBER_CMR_EMIT' (state, payload) {
    state.local.isShowNumberCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowNumberCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ORDER_CMR_EMIT' (state, payload) {
    state.local.isShowOrderCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowOrderCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GROUP_CMR_EMIT' (state, payload) {
    state.local.isShowGroupCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowGroupCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_VEHICLE_PLATE_CMR_EMIT' (state, payload) {
    state.local.isShowVehiclePlateCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowVehiclePlateCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TRAILER_PLATE_CMR_EMIT' (state, payload) {
    state.local.isShowTrailerPlateCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowTrailerPlateCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SECOND_TRAILER_PLATE_CMR_EMIT' (state, payload) {
    state.local.isShowSecondTrailerPlateCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowSecondTrailerPlateCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SENDER_PARTY_CMR_EMIT' (state, payload) {
    state.local.isShowSenderPartyCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowSenderPartyCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SENDER_CENTRE_CMR_EMIT' (state, payload) {
    state.local.isShowSenderCentreCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowSenderCentreCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEIVER_PARTY_CMR_EMIT' (state, payload) {
    state.local.isShowReceiverPartyCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowReceiverPartyCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_RECEIVER_CENTRE_CMR_EMIT' (state, payload) {
    state.local.isShowReceiverCentreCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowReceiverCentreCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATION_DATE_CMR_EMIT' (state, payload) {
    state.local.isShowCreationDateTimeCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowCreationDateTimeCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_CMR_EMIT' (state, payload) {
    state.local.isShowStatusCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowStatusCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERVICE_CMR_EMIT' (state, payload) {
    state.local.isShowServiceCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowServiceCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SEND_DATE_CMR_EMIT' (state, payload) {
    state.local.isShowSendDateCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowSendDateCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TRANSPORTIST_CMR_EMIT' (state, payload) {
    state.local.isShowTransportistCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowTransportistCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EMAIL_TRANSPORTIST_CMR_EMIT' (state, payload) {
    state.local.isShowEmailTransportistCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowEmailTransportistCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  
  // Columnas lineas emitidas
  'IS_SHOW_ITEMCODE_CMR_EMIT' (state, payload) {
    state.local.isShowItemCodeLinesCmrEmit = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.cmr.isShowItemCodeLinesCmrEmit = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // cmr borradores
  'CMR_DRAFT_STATE' (state, payload) {
    state.session.cmrDraft = payload
  },
  'QUERY_CMR_DRAFT_STATE' (state, payload) {
    state.session.queryCmrDraft = payload
  },
  'LIST_SELECTED_FILTERS_CMR_DRAFT_STATE' (state, payload) {
    state.session.listSelectedFiltersCmrDraft = payload
  }
   
}

export default {
  state,
  getters,
  actions,
  mutations
}
